// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardClaimModel {
    static getAttributeTypeMap() {
        return CardClaimModel.attributeTypeMap;
    }
}
CardClaimModel.discriminator = undefined;
CardClaimModel.attributeTypeMap = [
    {
        "name": "dateProcessed",
        "baseName": "dateProcessed",
        "type": "string"
    },
    {
        "name": "dateOfFill",
        "baseName": "dateOfFill",
        "type": "string"
    },
    {
        "name": "initialOutOfPocket",
        "baseName": "initialOutOfPocket",
        "type": "string"
    },
    {
        "name": "prescriberName",
        "baseName": "prescriberName",
        "type": "string"
    },
    {
        "name": "pharmacyName",
        "baseName": "pharmacyName",
        "type": "string"
    },
    {
        "name": "quantityDispensed",
        "baseName": "quantityDispensed",
        "type": "string"
    },
    {
        "name": "daysSupply",
        "baseName": "daysSupply",
        "type": "string"
    },
    {
        "name": "refillNumber",
        "baseName": "refillNumber",
        "type": "string"
    },
    {
        "name": "refillsAuthorized",
        "baseName": "refillsAuthorized",
        "type": "string"
    },
    {
        "name": "benefitPaid",
        "baseName": "benefitPaid",
        "type": "string"
    },
    {
        "name": "medication",
        "baseName": "medication",
        "type": "CardMedicationModel"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "ndcPromotionGroupId",
        "baseName": "ndcPromotionGroupId",
        "type": "string"
    },
    {
        "name": "claimStatus",
        "baseName": "claimStatus",
        "type": "string"
    },
    {
        "name": "rejectDescription",
        "baseName": "rejectDescription",
        "type": "string"
    },
    {
        "name": "mailInRebate",
        "baseName": "mailInRebate",
        "type": "string"
    }
];
//# sourceMappingURL=cardClaimModel.js.map